// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file driver_on_shift.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { DriverIncident, DriverIncidentJson } from "./driver_incident_pb";
import { file_driver_incident } from "./driver_incident_pb";
import type { DriverOnShiftEvent, DriverOnShiftEventJson, DriverOnShiftStatus, DriverOnShiftStatusJson, TruckType, TruckTypeJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { DateTimeFilter, DateTimeFilterJson, ListFilter, ListFilterJson, ListInfo, ListInfoJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Truck, TruckJson } from "./truck_pb";
import { file_truck } from "./truck_pb";
import type { User, UserJson } from "./user_pb";
import { file_user } from "./user_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file driver_on_shift.proto.
 */
export const file_driver_on_shift: GenFile = /*@__PURE__*/
  fileDesc("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", [file_driver_incident, file_enums, file_general, file_google_protobuf_struct, file_google_protobuf_timestamp, file_truck, file_user]);

/**
 * @generated from message raccoonai.DriverOnShiftEventIn
 */
export type DriverOnShiftEventIn = Message<"raccoonai.DriverOnShiftEventIn"> & {
  /**
   * @generated from field: required raccoonai.DriverOnShiftEvent event = 1;
   */
  event: DriverOnShiftEvent;

  /**
   * @generated from field: required uint64 driver_on_shift_id = 2 [json_name = "driver_on_shift_id"];
   */
  driverOnShiftId: bigint;

  /**
   * @generated from field: optional google.protobuf.Struct payload = 3;
   */
  payload?: JsonObject;
};

/**
 * @generated from message raccoonai.DriverOnShiftEventIn
 */
export type DriverOnShiftEventInJson = {
  /**
   * @generated from field: required raccoonai.DriverOnShiftEvent event = 1;
   */
  event?: DriverOnShiftEventJson;

  /**
   * @generated from field: required uint64 driver_on_shift_id = 2 [json_name = "driver_on_shift_id"];
   */
  driver_on_shift_id?: string;

  /**
   * @generated from field: optional google.protobuf.Struct payload = 3;
   */
  payload?: StructJson;
};

/**
 * Describes the message raccoonai.DriverOnShiftEventIn.
 * Use `create(DriverOnShiftEventInSchema)` to create a new message.
 */
export const DriverOnShiftEventInSchema: GenMessage<DriverOnShiftEventIn, {jsonType: DriverOnShiftEventInJson}> = /*@__PURE__*/
  messageDesc(file_driver_on_shift, 0);

/**
 * @generated from message raccoonai.DriverOnShift
 */
export type DriverOnShift = Message<"raccoonai.DriverOnShift"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required uint64 author_id = 3 [json_name = "author_id"];
   */
  authorId: bigint;

  /**
   * to be deprecated
   *
   * @generated from field: optional uint64 odometer_reading = 4 [json_name = "odometer_reading"];
   */
  odometerReading: bigint;

  /**
   * to be deprecated
   *
   * @generated from field: optional double fuel_level = 5 [json_name = "fuel_level"];
   */
  fuelLevel: number;

  /**
   * @generated from field: optional uint64 driver_id = 6 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: required uint64 truck_id = 7 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: required raccoonai.DriverOnShiftStatus status = 8;
   */
  status: DriverOnShiftStatus;

  /**
   * @generated from field: optional string comment = 9;
   */
  comment: string;

  /**
   * @generated from field: optional raccoonai.User driver = 10;
   */
  driver?: User;

  /**
   * @generated from field: optional raccoonai.Truck truck = 11;
   */
  truck?: Truck;

  /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 12 [json_name = "completed_at"];
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_idle_at = 13 [json_name = "last_idle_at"];
   */
  lastIdleAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_start_at = 14 [json_name = "tw_start_at"];
   */
  twStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_end_at = 15 [json_name = "tw_end_at"];
   */
  twEndAt?: Timestamp;

  /**
   * @generated from field: optional uint64 capacity = 16;
   */
  capacity: bigint;

  /**
   * @generated from field: optional bool visible_to_ai = 17 [json_name = "visible_to_ai"];
   */
  visibleToAi: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp started_at = 18 [json_name = "started_at"];
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: optional uint32 completed_route_count = 19 [json_name = "completed_route_count"];
   */
  completedRouteCount: number;

  /**
   * @generated from field: optional bool has_incidents = 20 [json_name = "has_incidents"];
   */
  hasIncidents: boolean;

  /**
   * @generated from field: repeated raccoonai.User crew = 21;
   */
  crew: User[];

  /**
   * Declared consignment-note facts, written only by ConsignmentNoteService.
   *
   * @generated from field: optional uint64 departure_location_id = 22 [json_name = "departure_location_id"];
   */
  departureLocationId: bigint;

  /**
   * @generated from field: optional uint64 arrival_location_id = 23 [json_name = "arrival_location_id"];
   */
  arrivalLocationId: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp departure_time = 24 [json_name = "departure_time"];
   */
  departureTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp arrival_time = 25 [json_name = "arrival_time"];
   */
  arrivalTime?: Timestamp;

  /**
   * @generated from field: optional double engine_hours = 26 [json_name = "engine_hours"];
   */
  engineHours: number;

  /**
   * @generated from field: optional double mileage = 27;
   */
  mileage: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp consignment_note_done_at = 28 [json_name = "consignment_note_done_at"];
   */
  consignmentNoteDoneAt?: Timestamp;

  /**
   * Set only by ForceCompleteDriverOnShift: the incident that ended the shift
   * ahead of its work (a shift-level type, with the dispatcher's explanation).
   *
   * @generated from field: optional raccoonai.DriverIncident force_complete_incident = 31 [json_name = "force_complete_incident"];
   */
  forceCompleteIncident?: DriverIncident;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message raccoonai.DriverOnShift
 */
export type DriverOnShiftJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required uint64 author_id = 3 [json_name = "author_id"];
   */
  author_id?: string;

  /**
   * to be deprecated
   *
   * @generated from field: optional uint64 odometer_reading = 4 [json_name = "odometer_reading"];
   */
  odometer_reading?: string;

  /**
   * to be deprecated
   *
   * @generated from field: optional double fuel_level = 5 [json_name = "fuel_level"];
   */
  fuel_level?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional uint64 driver_id = 6 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: required uint64 truck_id = 7 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: required raccoonai.DriverOnShiftStatus status = 8;
   */
  status?: DriverOnShiftStatusJson;

  /**
   * @generated from field: optional string comment = 9;
   */
  comment?: string;

  /**
   * @generated from field: optional raccoonai.User driver = 10;
   */
  driver?: UserJson;

  /**
   * @generated from field: optional raccoonai.Truck truck = 11;
   */
  truck?: TruckJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 12 [json_name = "completed_at"];
   */
  completed_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_idle_at = 13 [json_name = "last_idle_at"];
   */
  last_idle_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_start_at = 14 [json_name = "tw_start_at"];
   */
  tw_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_end_at = 15 [json_name = "tw_end_at"];
   */
  tw_end_at?: TimestampJson;

  /**
   * @generated from field: optional uint64 capacity = 16;
   */
  capacity?: string;

  /**
   * @generated from field: optional bool visible_to_ai = 17 [json_name = "visible_to_ai"];
   */
  visible_to_ai?: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp started_at = 18 [json_name = "started_at"];
   */
  started_at?: TimestampJson;

  /**
   * @generated from field: optional uint32 completed_route_count = 19 [json_name = "completed_route_count"];
   */
  completed_route_count?: number;

  /**
   * @generated from field: optional bool has_incidents = 20 [json_name = "has_incidents"];
   */
  has_incidents?: boolean;

  /**
   * @generated from field: repeated raccoonai.User crew = 21;
   */
  crew?: UserJson[];

  /**
   * Declared consignment-note facts, written only by ConsignmentNoteService.
   *
   * @generated from field: optional uint64 departure_location_id = 22 [json_name = "departure_location_id"];
   */
  departure_location_id?: string;

  /**
   * @generated from field: optional uint64 arrival_location_id = 23 [json_name = "arrival_location_id"];
   */
  arrival_location_id?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp departure_time = 24 [json_name = "departure_time"];
   */
  departure_time?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp arrival_time = 25 [json_name = "arrival_time"];
   */
  arrival_time?: TimestampJson;

  /**
   * @generated from field: optional double engine_hours = 26 [json_name = "engine_hours"];
   */
  engine_hours?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double mileage = 27;
   */
  mileage?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional google.protobuf.Timestamp consignment_note_done_at = 28 [json_name = "consignment_note_done_at"];
   */
  consignment_note_done_at?: TimestampJson;

  /**
   * Set only by ForceCompleteDriverOnShift: the incident that ended the shift
   * ahead of its work (a shift-level type, with the dispatcher's explanation).
   *
   * @generated from field: optional raccoonai.DriverIncident force_complete_incident = 31 [json_name = "force_complete_incident"];
   */
  force_complete_incident?: DriverIncidentJson;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.DriverOnShift.
 * Use `create(DriverOnShiftSchema)` to create a new message.
 */
export const DriverOnShiftSchema: GenMessage<DriverOnShift, {jsonType: DriverOnShiftJson}> = /*@__PURE__*/
  messageDesc(file_driver_on_shift, 1);

/**
 * @generated from message raccoonai.DriverOnShiftCreate
 */
export type DriverOnShiftCreate = Message<"raccoonai.DriverOnShiftCreate"> & {
  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional uint64 author_id = 2 [json_name = "author_id"];
   */
  authorId: bigint;

  /**
   * to be deprecated
   *
   * @generated from field: optional uint64 odometer_reading = 3 [json_name = "odometer_reading"];
   */
  odometerReading: bigint;

  /**
   * to be deprecated
   *
   * @generated from field: optional double fuel_level = 4 [json_name = "fuel_level"];
   */
  fuelLevel: number;

  /**
   * @generated from field: optional uint64 driver_id = 5 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: required uint64 truck_id = 6 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: optional string comment = 7;
   */
  comment: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_start_at = 8 [json_name = "tw_start_at"];
   */
  twStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_end_at = 9 [json_name = "tw_end_at"];
   */
  twEndAt?: Timestamp;

  /**
   * @generated from field: optional uint64 capacity = 10;
   */
  capacity: bigint;

  /**
   * @generated from field: optional bool visible_to_ai = 11 [json_name = "visible_to_ai"];
   */
  visibleToAi: boolean;

  /**
   * @generated from field: optional raccoonai.DriverOnShiftStatus status = 12;
   */
  status: DriverOnShiftStatus;

  /**
   * crew_ids are the users to put on the shift's crew, besides driver_id.
   *
   * @generated from field: repeated uint64 crew_ids = 13 [json_name = "crew_ids"];
   */
  crewIds: bigint[];
};

/**
 * @generated from message raccoonai.DriverOnShiftCreate
 */
export type DriverOnShiftCreateJson = {
  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional uint64 author_id = 2 [json_name = "author_id"];
   */
  author_id?: string;

  /**
   * to be deprecated
   *
   * @generated from field: optional uint64 odometer_reading = 3 [json_name = "odometer_reading"];
   */
  odometer_reading?: string;

  /**
   * to be deprecated
   *
   * @generated from field: optional double fuel_level = 4 [json_name = "fuel_level"];
   */
  fuel_level?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional uint64 driver_id = 5 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: required uint64 truck_id = 6 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: optional string comment = 7;
   */
  comment?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_start_at = 8 [json_name = "tw_start_at"];
   */
  tw_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_end_at = 9 [json_name = "tw_end_at"];
   */
  tw_end_at?: TimestampJson;

  /**
   * @generated from field: optional uint64 capacity = 10;
   */
  capacity?: string;

  /**
   * @generated from field: optional bool visible_to_ai = 11 [json_name = "visible_to_ai"];
   */
  visible_to_ai?: boolean;

  /**
   * @generated from field: optional raccoonai.DriverOnShiftStatus status = 12;
   */
  status?: DriverOnShiftStatusJson;

  /**
   * crew_ids are the users to put on the shift's crew, besides driver_id.
   *
   * @generated from field: repeated uint64 crew_ids = 13 [json_name = "crew_ids"];
   */
  crew_ids?: string[];
};

/**
 * Describes the message raccoonai.DriverOnShiftCreate.
 * Use `create(DriverOnShiftCreateSchema)` to create a new message.
 */
export const DriverOnShiftCreateSchema: GenMessage<DriverOnShiftCreate, {jsonType: DriverOnShiftCreateJson}> = /*@__PURE__*/
  messageDesc(file_driver_on_shift, 2);

/**
 * @generated from message raccoonai.DriverOnShiftUpdate
 */
export type DriverOnShiftUpdate = Message<"raccoonai.DriverOnShiftUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional uint64 odometer_reading = 3 [json_name = "odometer_reading"];
   */
  odometerReading: bigint;

  /**
   * @generated from field: optional double fuel_level = 4 [json_name = "fuel_level"];
   */
  fuelLevel: number;

  /**
   * @generated from field: optional uint64 driver_id = 5 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: optional uint64 truck_id = 6 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: optional raccoonai.DriverOnShiftStatus status = 7;
   */
  status: DriverOnShiftStatus;

  /**
   * @generated from field: optional string comment = 8;
   */
  comment: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 9 [json_name = "completed_at"];
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_idle_at = 10 [json_name = "last_idle_at"];
   */
  lastIdleAt?: Timestamp;

  /**
   * @generated from field: optional uint64 current_route_id = 11 [json_name = "current_route_id"];
   */
  currentRouteId: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_start_at = 12 [json_name = "tw_start_at"];
   */
  twStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_end_at = 13 [json_name = "tw_end_at"];
   */
  twEndAt?: Timestamp;

  /**
   * @generated from field: optional uint64 capacity = 14;
   */
  capacity: bigint;

  /**
   * @generated from field: optional bool visible_to_ai = 15 [json_name = "visible_to_ai"];
   */
  visibleToAi: boolean;

  /**
   * crew_ids, when non-empty, replaces the shift's whole crew. Leave it out to
   * keep the current crew; call ConsignmentNoteService.AddCrewMemberToShift with
   * an empty list to clear it.
   *
   * @generated from field: repeated uint64 crew_ids = 16 [json_name = "crew_ids"];
   */
  crewIds: bigint[];
};

/**
 * @generated from message raccoonai.DriverOnShiftUpdate
 */
export type DriverOnShiftUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional uint64 odometer_reading = 3 [json_name = "odometer_reading"];
   */
  odometer_reading?: string;

  /**
   * @generated from field: optional double fuel_level = 4 [json_name = "fuel_level"];
   */
  fuel_level?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional uint64 driver_id = 5 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: optional uint64 truck_id = 6 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: optional raccoonai.DriverOnShiftStatus status = 7;
   */
  status?: DriverOnShiftStatusJson;

  /**
   * @generated from field: optional string comment = 8;
   */
  comment?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 9 [json_name = "completed_at"];
   */
  completed_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_idle_at = 10 [json_name = "last_idle_at"];
   */
  last_idle_at?: TimestampJson;

  /**
   * @generated from field: optional uint64 current_route_id = 11 [json_name = "current_route_id"];
   */
  current_route_id?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_start_at = 12 [json_name = "tw_start_at"];
   */
  tw_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp tw_end_at = 13 [json_name = "tw_end_at"];
   */
  tw_end_at?: TimestampJson;

  /**
   * @generated from field: optional uint64 capacity = 14;
   */
  capacity?: string;

  /**
   * @generated from field: optional bool visible_to_ai = 15 [json_name = "visible_to_ai"];
   */
  visible_to_ai?: boolean;

  /**
   * crew_ids, when non-empty, replaces the shift's whole crew. Leave it out to
   * keep the current crew; call ConsignmentNoteService.AddCrewMemberToShift with
   * an empty list to clear it.
   *
   * @generated from field: repeated uint64 crew_ids = 16 [json_name = "crew_ids"];
   */
  crew_ids?: string[];
};

/**
 * Describes the message raccoonai.DriverOnShiftUpdate.
 * Use `create(DriverOnShiftUpdateSchema)` to create a new message.
 */
export const DriverOnShiftUpdateSchema: GenMessage<DriverOnShiftUpdate, {jsonType: DriverOnShiftUpdateJson}> = /*@__PURE__*/
  messageDesc(file_driver_on_shift, 3);

/**
 * @generated from message raccoonai.DriverOnShiftStatusUpdate
 */
export type DriverOnShiftStatusUpdate = Message<"raccoonai.DriverOnShiftStatusUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required raccoonai.DriverOnShiftStatus status = 2;
   */
  status: DriverOnShiftStatus;
};

/**
 * @generated from message raccoonai.DriverOnShiftStatusUpdate
 */
export type DriverOnShiftStatusUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required raccoonai.DriverOnShiftStatus status = 2;
   */
  status?: DriverOnShiftStatusJson;
};

/**
 * Describes the message raccoonai.DriverOnShiftStatusUpdate.
 * Use `create(DriverOnShiftStatusUpdateSchema)` to create a new message.
 */
export const DriverOnShiftStatusUpdateSchema: GenMessage<DriverOnShiftStatusUpdate, {jsonType: DriverOnShiftStatusUpdateJson}> = /*@__PURE__*/
  messageDesc(file_driver_on_shift, 4);

/**
 * @generated from message raccoonai.DriverOnShiftRequest
 */
export type DriverOnShiftRequest = Message<"raccoonai.DriverOnShiftRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required uint64 id = 2;
   */
  id: bigint;
};

/**
 * @generated from message raccoonai.DriverOnShiftRequest
 */
export type DriverOnShiftRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required uint64 id = 2;
   */
  id?: string;
};

/**
 * Describes the message raccoonai.DriverOnShiftRequest.
 * Use `create(DriverOnShiftRequestSchema)` to create a new message.
 */
export const DriverOnShiftRequestSchema: GenMessage<DriverOnShiftRequest, {jsonType: DriverOnShiftRequestJson}> = /*@__PURE__*/
  messageDesc(file_driver_on_shift, 5);

/**
 * @generated from message raccoonai.DriverOnShiftList
 */
export type DriverOnShiftList = Message<"raccoonai.DriverOnShiftList"> & {
  /**
   * @generated from field: repeated raccoonai.DriverOnShift driver_on_shifts = 1 [json_name = "driver_on_shifts"];
   */
  driverOnShifts: DriverOnShift[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.DriverOnShiftList
 */
export type DriverOnShiftListJson = {
  /**
   * @generated from field: repeated raccoonai.DriverOnShift driver_on_shifts = 1 [json_name = "driver_on_shifts"];
   */
  driver_on_shifts?: DriverOnShiftJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.DriverOnShiftList.
 * Use `create(DriverOnShiftListSchema)` to create a new message.
 */
export const DriverOnShiftListSchema: GenMessage<DriverOnShiftList, {jsonType: DriverOnShiftListJson}> = /*@__PURE__*/
  messageDesc(file_driver_on_shift, 6);

/**
 * @generated from message raccoonai.TruckDriverOnShiftListRequest
 */
export type TruckDriverOnShiftListRequest = Message<"raccoonai.TruckDriverOnShiftListRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required raccoonai.DateTimeFilter datetime_filter = 2 [json_name = "datetime_filter"];
   */
  datetimeFilter?: DateTimeFilter;

  /**
   * filter by truck type; empty = all trucks
   *
   * @generated from field: repeated raccoonai.TruckType truck_types = 3 [json_name = "truck_types"];
   */
  truckTypes: TruckType[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;
};

/**
 * @generated from message raccoonai.TruckDriverOnShiftListRequest
 */
export type TruckDriverOnShiftListRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required raccoonai.DateTimeFilter datetime_filter = 2 [json_name = "datetime_filter"];
   */
  datetime_filter?: DateTimeFilterJson;

  /**
   * filter by truck type; empty = all trucks
   *
   * @generated from field: repeated raccoonai.TruckType truck_types = 3 [json_name = "truck_types"];
   */
  truck_types?: TruckTypeJson[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;
};

/**
 * Describes the message raccoonai.TruckDriverOnShiftListRequest.
 * Use `create(TruckDriverOnShiftListRequestSchema)` to create a new message.
 */
export const TruckDriverOnShiftListRequestSchema: GenMessage<TruckDriverOnShiftListRequest, {jsonType: TruckDriverOnShiftListRequestJson}> = /*@__PURE__*/
  messageDesc(file_driver_on_shift, 7);

/**
 * endpoint for shift for truck for day
 *
 * @generated from message raccoonai.TruckDriverOnShift
 */
export type TruckDriverOnShift = Message<"raccoonai.TruckDriverOnShift"> & {
  /**
   * @generated from field: required raccoonai.Truck truck = 1;
   */
  truck?: Truck;

  /**
   * @generated from field: repeated raccoonai.DriverOnShift driver_on_shifts = 2 [json_name = "driver_on_shifts"];
   */
  driverOnShifts: DriverOnShift[];
};

/**
 * endpoint for shift for truck for day
 *
 * @generated from message raccoonai.TruckDriverOnShift
 */
export type TruckDriverOnShiftJson = {
  /**
   * @generated from field: required raccoonai.Truck truck = 1;
   */
  truck?: TruckJson;

  /**
   * @generated from field: repeated raccoonai.DriverOnShift driver_on_shifts = 2 [json_name = "driver_on_shifts"];
   */
  driver_on_shifts?: DriverOnShiftJson[];
};

/**
 * Describes the message raccoonai.TruckDriverOnShift.
 * Use `create(TruckDriverOnShiftSchema)` to create a new message.
 */
export const TruckDriverOnShiftSchema: GenMessage<TruckDriverOnShift, {jsonType: TruckDriverOnShiftJson}> = /*@__PURE__*/
  messageDesc(file_driver_on_shift, 8);

/**
 * @generated from message raccoonai.TruckDriverOnShiftList
 */
export type TruckDriverOnShiftList = Message<"raccoonai.TruckDriverOnShiftList"> & {
  /**
   * @generated from field: repeated raccoonai.TruckDriverOnShift truck_driver_on_shifts = 1 [json_name = "truck_driver_on_shifts"];
   */
  truckDriverOnShifts: TruckDriverOnShift[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.TruckDriverOnShiftList
 */
export type TruckDriverOnShiftListJson = {
  /**
   * @generated from field: repeated raccoonai.TruckDriverOnShift truck_driver_on_shifts = 1 [json_name = "truck_driver_on_shifts"];
   */
  truck_driver_on_shifts?: TruckDriverOnShiftJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.TruckDriverOnShiftList.
 * Use `create(TruckDriverOnShiftListSchema)` to create a new message.
 */
export const TruckDriverOnShiftListSchema: GenMessage<TruckDriverOnShiftList, {jsonType: TruckDriverOnShiftListJson}> = /*@__PURE__*/
  messageDesc(file_driver_on_shift, 9);

